import { render } from "./Home.vue?vue&type=template&id=711d8bb4"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=711d8bb4&lang=scss"

import exportComponent from "/web/bathroom-web2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__